import React from 'react';
import { Link } from 'gatsby';
import { motion } from 'framer-motion';

import { useScrollFreeze } from '@hooks/useScrollFreeze';
import { useNavQuery } from '@querys/useNavQuery';
import { useFooterQuery } from '@querys/useFooterQuery';
import SimplePortableText from '@components/sanity/simplePortableText';

import Exit from '@svg/exit.svg';

const bgVars = {
  initial: {
    opacity: 0,
  },
  animate: {
    opacity: 1,
  },
  exit: {
    opacity: 0,
  },
};

const menuVars = {
  initial: {
    x: '100%',
  },
  animate: {
    x: 0,
    transition: {
      type: 'spring',
      stiffness: 300,
      damping: 30,
    },
  },
  exit: {
    x: '100%',
    transition: {
      type: 'spring',
      stiffness: 300,
      damping: 30,
    },
  },
};

export const SideMenu = ({ toggleOpen, open }) => {
  useScrollFreeze();

  const { sideMenu, contactInfo } = useNavQuery();
  const { social } = useFooterQuery();

  return (
    <>
      {/* Background */}
      <motion.div
        key={open}
        variants={bgVars}
        initial='initial'
        animate='animate'
        exit='exit'
        className='z-[55] fixed top-0 left-0 w-full h-screen bg-black bg-opacity-25'
      />

      {/* Menu */}
      <motion.div
        key={open}
        variants={menuVars}
        initial='initial'
        animate='animate'
        exit='exit'
        className='fixed top-0 right-0 pl-20 pr-14 py-12 bg-white z-[60] text-teal h-screen overflow-y-scroll'>
        <div className='w-full flex justify-end'>
          <button
            onClick={toggleOpen}
            className='rounded-full w-16 h-16 bg-teal bg-opacity-10 hover:bg-opacity-100 nav-hover transition-standard'>
            <Exit className='p-5 w-full h-full' />
          </button>
        </div>
        <div className='text-right flex flex-col gap-y-4 text-xl mt-20'>
          {sideMenu.map(({ linkText, page }, i) => (
            <Link
              key={i}
              to={`/${page?.slug?.current}`}
              activeStyle={{ opacity: '60%' }}
              className='hover:opacity-60 transition-standard'>
              {linkText}
            </Link>
          ))}
        </div>
        <div className='mt-20 text-right'>
          {contactInfo && (
            <SimplePortableText
              text={contactInfo}
              className='!text-xs !text-teal'
            />
          )}
        </div>
        <div className='mt-8 flex gap-x-5 items-center justify-end'>
          {social?.socialHandles?.map(({ svg, link }, i) => (
            <a
              key={i}
              href={link}
              target='_blank'
              rel='noreferrer'
              dangerouslySetInnerHTML={{ __html: svg }}
            />
          ))}
        </div>
      </motion.div>
    </>
  );
};
